import { Box } from '@mui/material';
import { ReactNode } from 'react';

import { scrollEdgeFade } from 'theme/mixins';

interface ResponsiveTableProps {
    children: ReactNode;
    /** Fade the side that still has columns past it when the table scrolls sideways. */
    fadeOverflowEdges?: boolean;
}

export default function ResponsiveTable({ children, fadeOverflowEdges = false }: Readonly<ResponsiveTableProps>) {
    return (
        <Box sx={{ overflow: 'auto', ...(fadeOverflowEdges && scrollEdgeFade) }}>
            <Box sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}>{children}</Box>
        </Box>
    );
}
